const videoModalButton = () => {
  const videoModal = document.querySelector('.modal--video');
  const videoBtn = document.querySelectorAll('.tile--video');

  if (videoModal && videoBtn) {
    const closeVideoModal = videoModal.querySelector('.modal-close-button button');
    for (let item of videoBtn) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        item.querySelector('.tile__background').setAttribute('data-video-overlay', 'true');
        videoModal.classList.add('show');
        videoModal.style.display = 'block';
        document.querySelector('.modal-video-blur').classList.add('show');

        videoModal.querySelector('.ratio').classList.add(item.closest('.glide__slide').querySelector('video').getAttribute('data-ratio'));
        videoModal.querySelector('.ratio').appendChild(item.closest('.glide__slide').querySelector('video'));
        videoModal.querySelector('video').muted = false;
        videoModal.querySelector('video').removeAttribute('muted');
        videoModal.querySelector('video').setAttribute('controls', 'true');
        videoModal.querySelector('video').removeAttribute('loop');
        videoModal.querySelector('video').volume = .5;
        videoModal.querySelector('video').currentTime = 0
        videoModal.querySelector('video').play();
      });
    }

    closeVideoModal.addEventListener('click', function (e) {
      closeVideoModal.closest('.modal').classList.remove('show');
      closeVideoModal.closest('.modal').style.display = 'none';
      document.querySelector('.modal-video-blur').classList.remove('show');

      videoModal.querySelector('video').muted = true;
      videoModal.querySelector('video').setAttribute('muted', 'true');
      videoModal.querySelector('video').removeAttribute('controls', 'true');
      videoModal.querySelector('video').setAttribute('loop', 'true');
      videoModal.querySelector('video').setAttribute('autoplay', 'true');
      videoModal.querySelector('video').volume = 0;

      document.querySelector('[data-video-overlay]').appendChild(closeVideoModal.closest('.modal').querySelector('video'));
      document.querySelector('[data-video-overlay]').removeAttribute('data-video-overlay');
    });
  }
}
export default videoModalButton;
